import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Form, Button, Col } from 'react-bootstrap';
import { required } from '../../../../_utils/validators';
import { renderField } from '../../common/FormsControls.jsx';


const PlaylistNameEditForm = (props) => {
  const { anyTouched, invalid, submitting, handleSubmit } = props;

  const appendButton = (
    <Button variant="primary" type="submit" disabled={ submitting || invalid }
            title={ gettext('Сохранить') }>
      { gettext('Сохранить') }
    </Button>
  )

  return <Form onSubmit={ handleSubmit } className={ anyTouched ? ' was-validate' : '' }>
    <Form.Row>
      <Col xs={12}>
        <Field component={ renderField }
               element="input"
               required='required'
               name='name'
               validate={ [required] }
               placeholder={ gettext('Название плейлиста') }
               withInputGroup={ true }
               inputGroupAppendButton={ appendButton }
        />
      </Col>
    </Form.Row>
  </Form>
}

export default compose(
  connect(null, {}),
  reduxForm({ form: 'playlistEditForm' })
)(PlaylistNameEditForm);
